import React from 'react';
import Body from './Body';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from './Sidebar';

const Edit = (props) => {
  const checkTags =
    props?.properties?.tags?.length > 0 || props?.subjects?.length > 0;

  return checkTags ? (
    <div className="block page-tag">
      <Body {...props} isEditMode={true} />
      <SidebarPortal selected={props.selected}>
        <Sidebar {...props} />
      </SidebarPortal>
    </div>
  ) : (
    <></>
  );
};

export default Edit;
